export default function PageNotFound() {
  return (
    <div className="container py-5 text-center">
      <div className="pageNotFound">
        <p className="pageNotFound-text">
          Упс, такої сторінки не знайдено. 404 error &#128533;
        </p>
      </div>
    </div>
  );
}
